import React, {Component} from 'react'
import Button from '@material-ui/core/Button'
// import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import AttachMoney from '@material-ui/icons/AttachMoney'
import Dashboard from '@material-ui/icons/Dashboard'
import InsertChart from '@material-ui/icons/InsertChart'
import GoogleMapReact from 'google-map-react';

// const theme = createMuiTheme();


class Marker extends Component {

	constructor() {
		super()
		this.state = {
			hover: false,
			hoverList: false
		}
		this.hover = this.hover.bind(this)
		this.onLeave = this.onLeave.bind(this)
	}

	hover() {
		this.setState({hover: true})
	}

	onLeave() {
		this.setState({hover: false})
	}

	hoverList() {
		this.setState({hoverList: true})
	}

	onLeaveList() {
		this.setState({hoverList: false})
	}

	render(){
		return(
				<div>
				<div onMouseEnter={this.hover} onMouseLeave={this.onLeave} style={styles.dots}>

				</div>
				{
					this.state.hover ?
						<div style={styles.description}>
							<p style={{textAlign: 'center'}}>{this.props.event.dealTitle}</p>
							<img style={{height: 100, width: 200, margin: 25}} src={this.props.event.downloadURL} />
							<p>{this.props.event.address}</p>
							<p>{this.props.event.phone}</p>
						</div>
						: null
				}

				</div>

		)
	}

}

class Listing extends Component {

	constructor() {
		super()
		this.state = {
			hoverList: false
		}
		this.hoverList = this.hoverList.bind(this)
		this.onLeaveList = this.onLeaveList.bind(this)
	}

	hoverList() {
		if(this.state.hoverList){
			this.setState({hoverList: false})
		} else {
			this.setState({hoverList: true})
		}

	}

	onLeaveList() {
		this.setState({hoverList: false})
	}

	render() {
		return (

			<div>
			  <div role='button' onClick={this.hoverList} style={styles.listing}>
				{this.props.event.vendor}
			  </div>
			  {
			  	this.state.hoverList ?
			  	  <div style={styles.hoverList}>
				  	<p>{this.props.event.dealTitle}</p>
				  	<p>{this.props.event.description}</p>
				  	<p>Phone: {this.props.event.phone}</p>
				  	<p>Address: {this.props.event.address}</p>
				  </div>
				  : null
			  }

			  <hr />

			</div>


		)
	}
}

export default class MappedEvents extends Component {


	GMAP_API = process.env.REACT_APP_GEO_API;

	constructor(props){
		super(props)

		this.state ={
			center: {
				lat: 41.895293,
				lng: -88.165639
			},
			zoom: 10,
			events: null,
			markers: null,
			listing: null
		}
		this.getDeals = this.getDeals.bind(this);
	}


	componentDidMount() {
		let vendors = [];
		this.getDeals();
	}

	getDeals(){
		let mongo = process.env.REACT_APP_MONGO

		let api = "https://api.mlab.com/api/1/databases/funily/collections/deals?apiKey="+ mongo;

		fetch(api)
		.then( res => {
			return res.json();
		})
		.then(function(jsonRes){
			if(jsonRes.length > 0){
				let markers = jsonRes.map((marker,index) => (
				<Marker
					lat={marker.location.coordinates[0]}
					lng={marker.location.coordinates[1]}
					key={index}
					event={marker}
				/>
			))

			let listing = jsonRes.map((marker,index) => (
					<Listing
						event={marker}
						key={index}
					/>
				))

			this.setState({events: jsonRes,markers,listing})
			}

		}.bind(this))
		.catch(err => console.log('error getting deals',err));
	}


	render(){
		return (

			<div>
				<div>
					<div style={styles.heading}>
					<h1 style={{fontSize: "6em"}}>Funily | <span style={{fontSize: ".5em"}}>Events | Promos</span></h1>
						<div style={{border: '1px solid #ac9b37', width: "60%", marginBottom: 10, marginTop: 10}}></div>
					</div>
				</div>

				<div>

				{
					this.state.events ?
						<div style={styles.mapDiv}>
							<div style={{height: '100vh',flex: 3}}>
								<GoogleMapReact
						          bootstrapURLKeys={{ key: this.GMAP_API }}
						          defaultCenter={this.state.center}
						          defaultZoom={this.state.zoom}
						        >

						        {
						        	this.state.markers
						        }

						        </GoogleMapReact>
						    </div>

					        <div style={{flex: 2, overflowY: 'auto', paddingBottom: 20}}>
					        	{ this.state.listing }
					        </div>
					    </div>

				        : null

				}



				</div>



			</div>
		)
	}

}


const styles = {
	heading: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		backgroundColor: '#3748ac',
		// height: theme.spacing.unit * 50,
		paddingTop: 150,
		paddingBottom: 100,
		color: 'white',
		paddingLeft: 50,
		paddingRight: 20,
		borderRadius: 5
	},
	features: {
		display: 'flex',
		flexDirection: 'row',
		flexFlow: 'row wrap',
	},
	mapDiv: {
		height: '100vh',
		display: 'flex',
		flexWrap: 'wrap',
		flexDirection: 'row',
		marginTop: 20,
		marginBottom: 50
	},
	dots: {
		height: 10,
		width: 10,
		borderRadius: 10,
		backgroundColor: 'red'
	},
	description: {
		height: 300,
		width: 250,
		overFlowY: 'auto',
		fontSize: 12,
		zIndex: 20000,
		paddingTop: 10,
		paddingLeft: 10,
		paddingRight: 10,
		paddingBottom: 10,
		color: 'white',
		borderRadius: 10,
		backgroundColor: '#252457'
	},
	listing: {
		widht: '100%',
		margin: 15,
		fontSize: 16
	},
	hoverList: {
		height: 100,
		paddingTop: 5,
		paddingBottom: 15,
		paddingLeft: 20,
		overflowY: 'auto',
		backgroundColor: '#252457',
		color: 'white'
	}
}



// WEBPACK FOOTER //
// ./src/components/admin/MappedEvents.js